
import '../libs/local/easypick/index.bab.js';
import $ from "jquery";
import {dateToISOString, ISOStringToDate} from "../libs/@elements/date-utils";
import {refreshCurrent} from "./datepicker";
// import css_picker from '../../css/libs/local/easepick.css'
// import css_picker_custom from '../../css/style/easepick.css'
// export const easepick_styles = css_picker + css_picker_custom

export function initInScope ($scope) {
    // console.log("easypick");
    // import('@easepick/bundle').then(function (flatpickr){
    //
    // });
    // console.log("CSS!!!!!!!!!!!!!!!!!!!!!");
    // console.log(easepick_styles);
    var easyPickerElementsClass = ".js-easypicker-container";
    var easyPickerElements = $(easyPickerElementsClass);
    // console.log("easyPickerElements");
    // console.log(easyPickerElements);
    var mobileBreakpointXs = 768;
    var mobileBreakpoint = 992;
    var mobileJumpOffset = 220;

    var availabilityRange = 8;

    if(easyPickerElements.length > 0) {
        var dataLocale = easyPickerElements.first().data("locale");
        //add one day as this is saved for nights, easypick needs days tho
        var minDays = easyPickerElements.first().data("min-duration") + 1;
        if(!minDays) {
            minDays = 30;
        }

        var lang = "de-DE";

        let rangeLocale = {
            one: 'Nacht',
            other: 'Nächte'
        }
        if(dataLocale && dataLocale != "de") {
            lang = "en-US";
            rangeLocale = {
                one: 'Night',
                other: 'Nights'
            }
        }
        var footerInfoStr = easyPickerElements.first().data("footer-info");
        footerInfoStr = footerInfoStr.replace("%minNights%", '<span class="min-nights">' + (minDays - 1) + '</span>');
        var popUpHtml = '<div class="ep-popup temp" style="display: none;">' + footerInfoStr.replace("%minNights%", (minDays - 1)) + '</div>';
        var now = Date.now();
        var today = new Date(now);
        today.setHours(0,0,0,0);
        let easePickerFormatDate = function (date, type) {
            if(!date) {
                return null;
            }

            let day = date.getDate();
            let month = date.getMonth() + 1;
            // let month = date.format("MMM", lang);
            let year = date.getFullYear();
            if (day < 10) {
                day = '0' + day;
            }
            if (month < 10) {
                month = '0' + month;
            }
            if(type === "hidden") {
                return year + '-' + month + '-' + day + "T00:00:00"; //this time shit is nescessary sadly otherwise we need to refacture the whole search and the strange date handling
            } else {
                return date.format("D. MMM. YYYY", lang);
            }
        }

        let calculateMinDateTo = function (dateFrom) {
            let tmpDate = new Date(dateFrom.getTime());
            tmpDate.setDate(tmpDate.getDate() + (minDays - 1));
            return tmpDate
        }

        let calculateMaxDateFrom = function (dateFrom) {
            let tmpDate = new Date(dateFrom.getTime());
            tmpDate.setDate(tmpDate.getDate() - (minDays - 1));
            return tmpDate
        }




        easyPickerElements.each(function (i, el) {
            // console.log("processing each el");
            // console.log(i);
            // console.log(el);
            var myself = $(this);
            if(myself.hasClass("initialized")) {
                return true;
            }

            myself.addClass("initialized");

            let lockPluginFilterFc = null;


            // console.log($(this).data("wrapper-target"));
            var wrapperTarget = $(this).data("wrapper-target");
            var jsEpWrapper = wrapperTarget ? $(wrapperTarget) : $();

            // console.log(jsEpWrapper);
            var scrollToBlock = jsEpWrapper.parents(".objekt-detail-block:first");
            var scrollToBlockOffset = 90 + 48;
            var jsEpWrapperClass = ".js-easypick-wrapper";
            let hasTarget = true;
            if(jsEpWrapper.length <= 0) {
                // console.log("wrapper length <= 0 so w use the std class");
                hasTarget = false;
                jsEpWrapper = myself.find(jsEpWrapperClass);
            }
            // console.log("has target");
            // console.log(hasTarget);

            var dateFromContEl = $(this).find(".easypick-from-container");
            var dateToContEl = $(this).find(".easypick-to-container");


            var dateFromEl = dateFromContEl.find(".easypick-from");
            var dateToEl = dateToContEl.find(".easypick-to");
            var nightsCont = myself.find(".nights-container");
            var nightsEl = nightsCont.find(".nights-val");
            var dateFromHiddenEl = dateFromContEl.find(".easypick-from__hidden");
            var dateToHiddenEl = dateToContEl.find(".easypick-to__hidden");

            var preSelectedFrom = dateFromHiddenEl.val() ? new Date(dateFromHiddenEl.val()) : null;
            var preSelectedTo = dateToHiddenEl.val() ? new Date(dateToHiddenEl.val()) : null;

            // preSelectedFrom = null;
            // preSelectedTo = null;

            // if(preSelectedFrom < today.getTime()) {
            //     preSelectedFrom = null;
            //     preSelectedTo = null;
            // }
            // console.log("PRESELECTS: ", preSelectedFrom, preSelectedTo);
            var dateFromCloseEl = dateFromContEl.find(".easypick-close");
            var dateToCloseEl = dateToContEl.find(".easypick-close");


            var showAllEl = $(this).find(".mobile-search-someinfo");
            var showAllElSpan = showAllEl.find("span:first");
            var showAllElPh = showAllElSpan.data("placeholder");


            var ismobile = $(this).data("ismobile") === 1;
            if(ismobile) {
                availabilityRange = 14;
            }
            var bindEl = dateFromEl;
            var bindToEl = dateToEl;
            // var shadowRoot = document;
            var isInline = true;
            if(isInline && hasTarget) {
                bindEl = jsEpWrapper.find('.js-easypicker-position');
                bindToEl = jsEpWrapper.find('.js-easypicker-position-to');
            } else {
                bindEl = $(this).find('.js-easypicker-position');
                bindToEl = $(this).find('.js-easypicker-position-to');
            }
            // console.log("bindToEl");
            // console.log(bindToEl);
            // currSelectMode just used for the filter function, as its otherwise not really clear what "mode" the datepicker is in
            let currSelectMode = 'from';
            // console.log("CURRSELECTMODE: ", currSelectMode);
            let currDateFrom, currDateTo, currMinDateTo, currMaxDateFrom;
            let currDateFromString, currDateToString, currHiddenDateFromString, currHiddenDateToString;

            if(!ismobile && !hasTarget) {
                jsEpWrapper.parents(".portal-search-desktop:first").append(jsEpWrapper);
            } else {

            }


            let clearDateFromEls = function () {
                currDateFrom = null;
                dateFromEl.val("");
                dateFromEl.trigger("change");
                dateFromHiddenEl.val("");
                currSelectMode = 'from';
                // console.log("CURRSELECTMODE: ", currSelectMode);
            }
            let setDateFromEls = function () {
                // dateFromCloseEl.removeClass("hidden");
                dateFromEl.val(currDateFromString);
                dateFromEl.trigger("change");
                // let [day, month, year] = currDateFromString.split('.');
                dateFromHiddenEl.val(currHiddenDateFromString);
            }
            let clearDateToEls = function () {
                currDateTo = null;
                dateToEl.val("");
                dateToEl.trigger("change");
                dateToHiddenEl.val("");
            }
            let setDateToEls = function () {
                // dateToCloseEl.removeClass("hidden");
                dateToEl.val(currDateToString);
                dateToEl.trigger("change");
                // let [day, month, year] = currDateToString.split('.');
                dateToHiddenEl.val(currHiddenDateToString);
            }
            let markFirstAvailable = function (dateFrom, picker) {
                // console.log("marking first available");
                let container = $(picker.ui.container);
                // console.log(container);
                // console.log(container.find(".day .border-radius.first-available"));
                container.find(".day .border-radius.first-available").removeClass("first-available");
                if(dateFrom) {
                    container.find('.day[data-time="'+currMinDateTo.getTime()+'"] .border-radius').addClass("first-available");
                }
            }

            let updateSomeInfo = function () {
                if(!ismobile) {
                    return;
                }
                // console.log("updating someinfo");
                let dateFromStr = dateFromEl.val();
                let dateToStr = dateToEl.val();
                if(dateFromStr && dateToStr) {
                    showAllElSpan.text(dateFromStr + " - " + dateToStr);
                } else if(dateFromStr) {
                    showAllElSpan.text(dateFromStr + " - ");
                } else {
                    showAllElSpan.text(showAllElPh);
                }
            }
            let doSelection = function (e, picker) {
                // console.log("DOING SELECTION");
                // console.log(e.detail);
                const lock = picker.PluginManager.getInstance('LockPlugin');
                let omitGotoCal = e.detail.omitGotoCal ? e.detail.omitGotoCal : false;
                let omitNewPrice = e.detail.omitGotoCal ? e.detail.omitGotoCal : false;

                // console.log('********************************************** omitGotoDate', omitGotoDate);
                // console.log('currSelectMode ', currSelectMode);
                // if(currSelectMode === "to") {
                //     lock.options.minDays = 1;
                //     picker.renderAll();
                // } else {
                //     lock.options.minDays = minDays;
                //     picker.renderAll();
                // }
                if(e.detail.start) {
                    // console.log("setting currDateFrom");
                    currDateFrom = e.detail.start.clone();
                    currMinDateTo = calculateMinDateTo(currDateFrom);
                    currDateFromString = easePickerFormatDate(currDateFrom);
                    currHiddenDateFromString = easePickerFormatDate(currDateFrom, "hidden");
                }

                if(e.detail.end) {
                    currDateTo = e.detail.end.clone();
                    currMaxDateFrom = calculateMaxDateFrom(currDateTo);
                    currDateToString = easePickerFormatDate(currDateTo);
                    currHiddenDateToString = easePickerFormatDate(currDateTo, "hidden");
                }

                // console.log("-----------------------------------");
                // console.log(e.detail.start);
                // console.log(e.detail.start);
                // console.log(e.detail.end);
                // console.log(currDateFrom);
                // console.log(currDateTo);
                var gotodate = null;
                var isMinDateTo = false;
                var isValidDate = false;
                if(currDateFrom && currDateTo) {
                    // console.log("checking mindays and applying --------------------------");
                    let applyBtn = $(picker.ui.container).find(".apply-button");
                    if(currMinDateTo.getTime() > currDateTo.getTime() || currMaxDateFrom.getTime() < currDateFrom.getTime()) {
                        // console.log("daterange invalid  --------------------------");
                        picker.clear();
                        clearDateToEls();

                        picker.setStartDate(currDateFrom);
                        setDateFromEls();

                        picker.datePicked = [picker.getStartDate()];
                        picker.renderAll();
                        if(!omitGotoCal) {
                            dateToEl.trigger("click");
                        }

                        gotodate = picker.getStartDate();
                        if(ismobile) {
                            gotodate = calculateMinDateTo(gotodate);
                            isMinDateTo = true;
                        }
                        gotoDate(gotodate, picker, false, isMinDateTo);

                        nightsCont.hide();
                        updateSomeInfo();
                        return;
                    } else {
                        // console.log("daterange valid  --------------------------");
                        // console.log(e.detail);
                        // console.log(omitNewPrice);
                        if(!omitNewPrice) {
                            // console.log(!omitNewPrice);
                            // console.log("BEFORE LOADING NEW PRICE do selection");
                            let rangePlugin = picker.PluginManager.getInstance("RangePlugin");
                            if(rangePlugin.options.loadNewPrice !== null) {
                                rangePlugin.options.loadNewPrice(currDateFrom, currDateTo);
                            }
                        }

                        picker.setDateRange(currDateFrom, currDateTo);
                        currSelectMode = "from";
                        // console.log("CURRSELECTMODE: ", currSelectMode);
                        //mark in range els then reset datePicked to allow selection inside usually blocked dates (cuz of minDate)
                        picker.datePicked = [picker.getStartDate(), picker.getEndDate()];
                        picker.renderAll();
                        picker.datePicked = [];
                        picker.renderAll();

                        nightsEl.text(picker.getEndDate().diff(picker.getStartDate()))
                        nightsCont.show();

                        //history push
                        if(!omitNewPrice) {
                            updateUrlParams({ from: currHiddenDateFromString, to: currHiddenDateToString }, { replace: true }); // replaceState
                        }
                        //js-easypicker-container content-search-box initialized + form control
                        // remove gray and white
                        isValidDate = true;
                    }
                }
                // console.log("currDateFrom befor mark");
                // console.log(currDateFrom);
                markFirstAvailable(currDateFrom, picker);

                if(e.detail.start) {
                    setDateFromEls();
                }
                if(e.detail.end) {
                    setDateToEls();
                }

                if (currDateFrom && currDateTo) {
                    if(!omitGotoCal) {
                        dateFromEl.trigger("focus");
                    }
                } else if (currDateFrom && !currDateTo) {
                    picker.setStartDate(currDateFrom);
                    gotodate = currDateFrom;
                    if (ismobile) {
                        gotodate = calculateMinDateTo(gotodate);
                        isMinDateTo = true;
                    }
                    if(!e.detail.omitGotoDate) {
                        gotoDate(gotodate, picker, false, isMinDateTo);
                    }
                    if(!omitGotoCal) {
                        dateToEl.trigger("click");
                    }
                }

                updateSomeInfo();
                if(isValidDate) {
                    // console.log("remove gray at end");
                    myself.removeClass("gray");
                    myself.find(".content-search-fromto").removeClass("white");
                    myself.find(".easypick-close").hide();
                }
            }



            let gotoDate = function(date, picker, isEnd = false, isMinDateTo = false) {
                // console.log("------------- gotodate -------------");
                if(ismobile) {
                    // console.log("------------- WE ARE MOBILE -------------");
                    let jumpEl = null;
                    if(isMinDateTo) {
                        // console.log("seeking first avail");
                        jumpEl = $(picker.ui.container).find(".day .first-available");
                    } else if(!isEnd) {
                        jumpEl = $(picker.ui.container).find(".day.start");
                        // console.log("seeking start");
                    } else {
                        jumpEl = $(picker.ui.container).find(".day.end");
                        // console.log("seeking end");
                    }

                    if(jumpEl.length > 0) {
                        let pullupContainer = $('.portal-search-mobile-pullup').eq(0);
                        let jumpElTarget = (jumpEl.offset().top - pullupContainer.offset().top) + pullupContainer.scrollTop() - mobileJumpOffset;
                        // console.log("document.activeElement");
                        // console.log(document.activeElement);

                        $(".portal-search-mobile-pullup").animate({ scrollTop: jumpElTarget}, 500);

                        // console.log($(".portal-search-mobile-pullup").scrollTop());
                    } else {
                        easypicker.gotoDate(date);
                        // $(".portal-search-mobile-pullup").scrollTop(0); //gotta because the pullup is outside the wrappers
                        $(".portal-search-mobile-pullup").animate({ scrollTop: 0 }, 500); //gotta because the pullup is outside the wrappers
                    }

                } else {
                    easypicker.gotoDate(date);
                }
                // console.log("------------- gotodate end -------------");
            }
            let scrollToTarget = function(target, offset) {
                // console.log("starting scrolling");
                $('html, body').animate({
                    scrollTop: target.offset().top - offset
                }, 300);
            }
            var calendarsNr = 2;
            var gridNr = 2;
            if(ismobile) {
                if(screen.width >= mobileBreakpointXs) {
                    calendarsNr = 6;
                    gridNr = 2;
                } else {
                    calendarsNr = 6;
                    gridNr = 1;
                }

            }

            // AVAILABILITYSTUFF
            let loadNewPrice = null;
            if(myself.data('avail-url')) {
                // console.log("has avail");

                let hasAvailabilities = true;
                let availUrl = myself.data('avail-url');
                let recalcUrl = myself.data('recalc-url');
                let recalcTarget = $(myself.data('recalc-target'));
                let bookingBox = myself.parents('.sticky-box:first');
                // console.log("bookingBox");
                // console.log(bookingBox);
                let form = $(myself.parents('form:first'));
                let personsTarget = form.find('input[name="persons"]');
                let watchlistTarget = $(myself.data('watchlist-target'));
                // console.log(" watchlistTarget");
                // console.log( watchlistTarget);
                if(personsTarget.length <= 0) {
                    personsTarget = bookingBox.find('input[name="persons"]');
                }
                // console.log("persons");
                // console.log(personsTarget);
                let availabilitiesFrom = {};
                let availabilitiesFromExt = {};
                let availabilitiesTo = {};

                lockPluginFilterFc = function (date,pickedDates) {
                    let formatedDate = easePickerFormatDate(date, 'hidden');
                    // console.log(formatedDate);

                    if (currDateFrom !== null && currDateTo === null || currSelectMode === "to") {
                        if(typeof availabilitiesTo[formatedDate] !== 'undefined' && !availabilitiesTo[formatedDate] && currDateFrom.getTime() !== date.getTime()) {
                            this.availabilitiesTrulyBlocked[date.getTime()] = true;
                            return true;
                        }
                        // if($.inArray(formatedDate, availabilitiesTo) > -1 && currDateFrom.getTime() !== date.getTime()) {
                        //     return true;
                        // }
                    } else {
                        if(typeof availabilitiesFrom[formatedDate] !== 'undefined' && !availabilitiesFrom[formatedDate]) {
                            this.availabilitiesTrulyBlocked[date.getTime()] = true;
                            return true;
                        }
                        if(typeof availabilitiesFromExt[formatedDate] !== 'undefined' && !availabilitiesFromExt[formatedDate]) {
                            return true;
                        }

                        // if($.inArray(formatedDate, availabilitiesFrom) > -1) {
                        //     return true;
                        // }
                    }

                    return false;
                }

                let isLoading = false;
                let overlay = $('.easypick-loading-overlay');

                loadNewPrice = function (dateFrom = null, dateTo = null, persons = null) {
                    // console.log("LOAD NEW PRICE");
                    if(isLoading) {
                        // console.log("already loading recalc");
                        return;
                    }
                    let fromString = null;
                    let toString = null;
                    if(dateFrom === null) {
                        fromString = dateFromHiddenEl.val();
                    } else {
                        fromString = easePickerFormatDate(dateFrom, 'hidden');
                    }
                    if(dateTo === null) {
                        toString = dateToHiddenEl.val();
                    } else {
                        toString = easePickerFormatDate(dateTo, 'hidden');
                    }
                    if(persons === null) {
                        persons = personsTarget.val();
                    }

                    overlay.show();
                    isLoading = true;

                    $.ajax(recalcUrl, {
                        type: 'POST',
                        data: {
                            from: fromString,
                            to: toString,
                            persons: persons,
                            n: '1'
                        },

                        dataType: 'JSON'
                    }).then(response => {
                        if (response && response.success) {
                            recalcTarget.html(response.html);
                            //insert new watchlist link
                            //sticky-box d-none d-sm-block
                            let watchlistData = recalcTarget.find(".watchlist-data");
                            // console.log("in ajax booking box");
                            // console.log(watchlistTarget);
                            // console.log("watchlistData");
                            // console.log(watchlistData);
                            // console.log(watchlistData.html());
                            if(watchlistTarget.length > 0) {
                                watchlistTarget.html(watchlistData.html());
                            }
                            if(bookingBox.length > 0) {
                                recalcTarget.find('[data-toggle="tooltip"]').tooltip(); //do only for desktop
                            }
                            let paymentSummaryModal = $("#paymentSummaryModal")
                            if(paymentSummaryModal.length > 0) {
                                paymentSummaryModal.find('.payment-summary-content').html(response.paymentSummary);
                            }

                        }
                    }).catch((...params) => {
                        console.error(...params);
                    }).always(function () {
                        isLoading = false;
                        overlay.hide();
                    });
                }
                personsTarget.on("change", function (e) {
                    let personsValue = $(this).val();
                    if(loadNewPrice !== null) {
                        loadNewPrice();
                    }
                    //get dates from hidden vals
                    let fromDate = dateFromHiddenEl.val();
                    let toDate = dateToHiddenEl.val();
                    updateUrlParams({"from": fromDate, "to": toDate, "persons": personsValue}, { replace: true });
                });


                let alreadyLoaded = {from: null, to: null};
                window.getAvailabilities = function(from, to, type = null, callback = null) {
                    if(isLoading) {
                        // console.log("already loading");
                        return;
                    }
                    isLoading = true;

                    // console.log("----------------------------");
                    // console.log("getavails start", from, to);
                    // console.log(from);
                    // console.log(to);
                    // console.log(" ");
                    // console.log("alreadyloaded:");
                    // console.log(alreadyLoaded);
                    // console.log(" ");
                    // console.log("from to params", from, to);
                    // 2) if we’ve already loaded a range that fully contains [fromDate, toDate], skip
                    if (alreadyLoaded.from instanceof Date &&
                        alreadyLoaded.to   instanceof Date &&
                        from.getTime() >= alreadyLoaded.from.getTime() &&
                        to.getTime()   <= alreadyLoaded.to.getTime()
                    ) {
                        // console.log("avails already loaded");
                        isLoading = false;
                        return;
                    }
                    if(type !== 'init') {
                        overlay.show();
                    }

                    // isLoading = true;
                    let toSaveFrom = from;
                    let toSaveTo = to;
                    if (alreadyLoaded.from instanceof Date && alreadyLoaded.to instanceof Date) {
                        if (from.getTime() < alreadyLoaded.from.getTime() && to.getTime() <= alreadyLoaded.to.getTime()) {
                            //only fromDate is needed
                            toSaveTo = alreadyLoaded.to;
                            //overwrite to date to connect with already loaded fromdate
                            to = alreadyLoaded.from;
                            //overwrite from date to extend the range more than one month
                            // from = new Date(from.getFullYear(), from.getMonth() - 2, 1, 0, 0, 0, 0);
                            from.setMonth(from.getMonth() - 2);
                            from.setDate(1);
                            from.setHours(0, 0, 0);
                        } else if (from.getTime() >= alreadyLoaded.from.getTime() && to.getTime() > alreadyLoaded.to.getTime()) {
                            //only toDate is needed
                            toSaveFrom = alreadyLoaded.from;
                            //overwrite from date to connect with already loaded todate
                            from = alreadyLoaded.to;
                            //overwrite to date to extend the range more than one month
                            // to = new Date(to.getFullYear(), to.getMonth() + availabilityRange, 0, 23, 59, 59, 999);;
                            to.setMonth(to.getMonth() + availabilityRange + 1);
                            to.setDate(0);
                            to.setHours(23, 59, 59);
                        }
                    }



                    // console.log("avails NOT already loaded, proceeding");
                    // console.log("from to params", from, to);



                    let availFromString = easePickerFormatDate(from, 'hidden');
                    let availToString = easePickerFormatDate(to, 'hidden');

                    $.ajax(availUrl, {
                        data: {
                            from: availFromString,
                            to: availToString,
                            n: '1'
                        },
                        dataType: 'JSON'
                    }).then(response => {
                        if (response && response.success) {
                            if (response.occupiedDates) {
                                response.occupiedDates["from"].forEach(dateString => {
                                    // availabilitiesFrom.push(dateString);
                                    availabilitiesFrom[dateString] = false;
                                });
                                response.occupiedDates["to"].forEach(dateString => {
                                    // availabilitiesTo.push(dateString);
                                    availabilitiesTo[dateString] = false;
                                });
                                response.occupiedDatesExt["from"].forEach(dateString => {
                                    // availabilitiesTo.push(dateString);
                                    // availabilitiesFrom.push(dateString);
                                    availabilitiesFromExt[dateString] = false;
                                });
                            }
                            alreadyLoaded.from = toSaveFrom;
                            alreadyLoaded.to = toSaveTo;

                            // if(render) {
                            //     console.log("RENDERALL AFTER AJAX");
                            //     easypicker.renderAll();
                            // }

                            // console.log("alreadyLoaded after ajax: ");
                            // console.log(alreadyLoaded);
                            // console.log(availabilitiesFrom);
                            // console.log(availabilitiesTo);
                            if(callback) {
                                callback();
                            }
                            easypicker.renderAll();
                        }
                    }).catch((...params) => {
                        console.error(...params);
                    }).always(function () {
                        isLoading = false;
                        overlay.hide();
                    });

                }

            }
            // console.log("--------------------befor ep");
            // AVAILABILITYSTUFF END
            let lastView;
            var easypicker = new easepick.create({
                // doc: shadowRoot,
                element: bindEl[0],
                plugins: [
                    "RangePlugin",
                    "LockPlugin"
                ],
                LockPlugin: {
                    minDays: 1,
                    // minDays: minDays,
                    maxDays: 365,
                    minDate: "2024-07-16T00:00:00.000Z",
                    inseparable: true,
                    filter: lockPluginFilterFc,
                    availabilitiesTrulyBlocked: {},
                },
                RangePlugin: {
                    strict: false,
                    repick: true,
                    elementEnd: bindToEl[0],
                    tooltipNumber: function (nr) {
                        return nr - 1;
                    },
                    startDate: preSelectedFrom ? preSelectedFrom.getTime() : null, //handle directly throught he datefields, as we do a lot aof stuff there
                    endDate: preSelectedTo ? preSelectedTo.getTime() : null,
                    locale: rangeLocale,
                    loadNewPrice: loadNewPrice
                },
                lang: lang,
                // locale: {
                //     nextMonth: '<svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16"><path fill="#323232" d="M12.5,14.7143258 L19.0516073,8.16271845 C19.2685653,7.94576052 19.6203236,7.94576052 19.8372815,8.16271845 C20.0542395,8.37967639 20.0542395,8.73143472 19.8372815,8.94839266 L12.8928371,15.8928371 C12.6758792,16.109795 12.3241208,16.109795 12.1071629,15.8928371 L5.16271845,8.94839266 C4.94576052,8.73143472 4.94576052,8.37967639 5.16271845,8.16271845 C5.37967639,7.94576052 5.73143472,7.94576052 5.94839266,8.16271845 L12.5,14.7143258 Z" transform="rotate(-90 6.5 14.028)"/></svg>',
                //     previousMonth: '<svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16"><path fill="#323232" d="M12.5,14.7143258 L19.0516073,8.16271845 C19.2685653,7.94576052 19.6203236,7.94576052 19.8372815,8.16271845 C20.0542395,8.37967639 20.0542395,8.73143472 19.8372815,8.94839266 L12.8928371,15.8928371 C12.6758792,16.109795 12.3241208,16.109795 12.1071629,15.8928371 L5.16271845,8.94839266 C4.94576052,8.73143472 4.94576052,8.37967639 5.16271845,8.16271845 C5.37967639,7.94576052 5.73143472,7.94576052 5.94839266,8.16271845 L12.5,14.7143258 Z" transform="rotate(-90 6.5 14.028)"/></svg>'
                // },
                format: "DD.MMM.YYYY",
                calendars: calendarsNr,
                grid: gridNr,
                zIndex: 100,
                inline: isInline,
                autoApply: false,
                css: [
                    '/static/css/libs/local/easepick.css' + "?" + now,
                    // '/static/css/style/easepick-add.min.css' + "?" + now,
                    '/static/css/style/easepick.css' + "?" + now,
                ],
                setup(easypicker) {
                    // console.log("ep SETUP");
                    // console.log(easypicker);
                    let epContainer = $(easypicker.ui.container);
                    let rootNode = epContainer[0].getRootNode();


                    let popUp = $(popUpHtml)
                    rootNode.appendChild(popUp[0]);

                    var lastTouchTs = 0;
                    var currentDay = null;
                    var hideTimer = null;
                    function handlePopUp(day, e, type = 'click') {
                        e.preventDefault();
                        e.stopPropagation();
                        e.stopImmediatePropagation();
                        // console.log("handling");
                        // console.log(type);
                        // console.log(e);
                        if(type === 'pointerout') {
                            return;
                        }
                        epContainer.find('.ep-popup').hide();
                        let tmpPopup = $(day).find('.ep-popup');
                        if(tmpPopup.length <= 0) {
                            tmpPopup = $(rootNode.querySelector('.ep-popup')).clone();
                            tmpPopup.removeClass("temp");
                            $(day).append(tmpPopup);
                        }
                        tmpPopup.show();
                        hideTimer = setTimeout(function () {
                            hidePopUp()
                        }, 1000);

                        // if(type === 'click') {
                        //     hideTimer = setTimeout(function () {
                        //         hidePopUp()
                        //     }, 2000);
                        // }

                    }
                    function hidePopUp() {
                        // clearTimeout(hideTimer);
                        epContainer.find('.ep-popup').hide();
                        currentDay = null;
                    }
                    function handleRootDayEvents(e, type = 'click') {
                        // Get the composed path (fallback for older browsers)
                        var path = e.composedPath ? e.composedPath() : getEventPath(e);
                        // Find the first node with class "day"
                        var day = null;
                        for (var i = 0; i < path.length; i++) {
                            var n = path[i];
                            if (n && n.classList && n.classList.contains('day')) {
                                day = n;
                                break;
                            }
                        }
                        if (!day || !$(day).hasClass('locked')) return;
                        // Skip synthetic click after touch
                        if (type === 'click' && Date.now() - lastTouchTs < 350) return;
                        // Ignore pointerout if we’re still inside the same day
                        if (type === 'pointerout' && day.contains(e.relatedTarget)) return;

                        handlePopUp(day, e, type);

                    }
                    rootNode.addEventListener('click', function (e) {
                        // console.log('clicking');
                        handleRootDayEvents(e, 'click');
                    }, { capture: true });

                    rootNode.addEventListener('pointerover', function (e) {
                        handleRootDayEvents(e, 'pointerover');
                    }, true);
                    rootNode.addEventListener('pointerout', function (e) {
                        handleRootDayEvents(e, 'pointerout');
                    }, true);

                    // let overlay = $('<div class="ep-loading-overlay" style="display: none;">Loading…</div>')

                    // overlay.removeClass("template");
                    // jsEpWrapper.find(".js-easypick-wrapper-inner").append(overlay);

                    //Monkey patches
                    // 1) grab the original method
                    const originalGoto = easypicker.gotoDate.bind(easypicker);
                    // 2) overwrite it
                    easypicker.gotoDate = function(date) {
                        // console.log("going to date monkey patch");
                        // console.log(date);
                        // a) perform the normal navigation
                        originalGoto(date);
                    };
                    // 1) keep a reference to the original
                    const orig = easypicker.onClickHeaderButton.bind(easypicker);
                    // 2) replace it
                    easypicker.onClickHeaderButton = function(button) {
                        orig(button);
                        let cal0, tmpCurrDate, tmpNewFrom, tmpNewTo;
                        if($(button).hasClass("next-button") || $(button).hasClass("previous-button")) {
                            // console.log("next monkey patch");
                            // console.log(easypicker);
                            // 2) grab the first visible month from calendars[0]
                            cal0 = easypicker.calendars[0];
                            // console.log(cal0);
                            // if it's a Day.js object, turn it into a JS Date:
                            tmpCurrDate = (typeof cal0.toDate === 'function')
                                ? cal0.toDate()
                                : cal0;
                            tmpNewFrom = new Date(tmpCurrDate.getFullYear(), tmpCurrDate.getMonth() - 2, 1, 0,0,0);
                            //divide by 2 to not load availabilities each next month cloick but only if were getting close
                            tmpNewTo = new Date(tmpCurrDate.getFullYear(), tmpCurrDate.getMonth() + Math.round(availabilityRange / 2), 0,23,59,59);
                            // year  = viewDate.getFullYear();
                            // month = viewDate.getMonth() + calendarsNr + 2; // 1–12
                            window.getAvailabilities(tmpNewFrom, tmpNewTo);
                        }
                        // if($(button).hasClass("previous-button")) {
                        //     console.log("prev monkey patch");
                        //     // 2) grab the first visible month from calendars[0]
                        //     cal0 = easypicker.calendars[0];
                        //     console.log(cal0);
                        //     // if it's a Day.js object, turn it into a JS Date:
                        //     viewDate = (typeof cal0.toDate === 'function')
                        //         ? cal0.toDate()
                        //         : cal0;
                        //
                        //     year  = viewDate.getFullYear();
                        //     month = viewDate.getMonth() + calendarsNr + 2; // 1–12
                        //     console.log('Now showing:', year, month);
                        // }

                    };


                    easypicker.on("render", function (e) {
                        // console.log('RENDER');
                        const lockPlugin = easypicker.PluginManager.getInstance("LockPlugin");
                        if(!ismobile) {
                            let footerEl = $(easypicker.ui.container).find("footer");
                            let footerInfoEl = footerEl.find(".footer-info");
                            if(footerInfoEl.length <= 0) {
                                footerEl.append('<div class="footer-info">' + footerInfoStr + '</div>');
                            }
                        }
                        $(e.target).find(".day").each(function () {
                            var addClasses = "";
                            if($(this).data("time") < today.getTime()) {
                                // console.log("setting past day");
                                addClasses = addClasses + " past-day";
                            }
                            let logTime = new Date();
                            logTime.setTime($(this).data("time"))
                            // console.log(lockPlugin.options.availabilitiesTrulyBlocked);
                            if(typeof lockPlugin.options.availabilitiesTrulyBlocked[$(this).data("time")] !== undefined && lockPlugin.options.availabilitiesTrulyBlocked[$(this).data("time")]) {
                                // console.log("has real lock");
                                // console.log(logTime);
                                // console.log(easypicker.availabilitiesTrulyBlocked);
                                this.style.setProperty('pointer-events', 'none', 'important'); //hack for older browsers. may be possible to use a data attribute for that so we could do it via css. thing is, the classlist gets updated in easypick at some point so we cant just add a class
                                addClasses = addClasses + " t-blocked";
                            } else {
                                // console.log("removing loc for");
                                // console.log(logTime);
                                this.style.removeProperty('pointer-events');
                            }
                            var tmpHtml = $(this).text();
                            $(this).html('<div class="border-radius ' + addClasses + '">' + tmpHtml + '</div>');
                        });
                        markFirstAvailable(currDateFrom, easypicker);
                    });

                    easypicker.on("preselect", function (e) {
                        // console.log("EP: PRESELECTED");
                        // console.log(e);
                        // console.log(e.detail);
                        // console.log(easypicker.datePicked);

                        easypicker.PluginManager.instances.RangePlugin.triggerElement = undefined;
                        // easypicker.PluginManager.reloadInstance('LockPlugin');
                        doSelection(e, easypicker);


                        // // console.log(easypicker);
                        // console.log(this);
                        // tmpDate.setDate(tmpDate.getDate() + (easypicker.options.LockPlugin.minDays - 1));
                        // console.log(tmpDate);
                        // console.log(tmpDate.getTime());
                        // $(this).find(".first-available").removeClass("first-available");
                        // console.log("FINDING SPCIFIC DAY EL");
                        // console.log($(this).find('.day[data-time="'+tmpDate.getTime()+'"]'));
                        // $(this).find('.day[data-time="'+tmpDate.getTime()+'"]').addClass("first-available");
                    });
                    easypicker.on("select", function (e) {
                        // console.log("EP: SELECTED");
                        // console.log(e);
                        // console.log(easypicker);
                        // console.log(e.detail);
                        // if(ismobile) {
                        //     //doSelection(e, easypicker);
                        // }
                        // doSelection(e, easypicker);

                    });

                    // let epWrapper = jsEpWrapper.find(".easepick-wrapper");
                    if(!ismobile) {
                        // dateFromEl.on("click", function (e) {
                        //     e.stopPropagation();
                        // });
                        // dateToEl.on("click", function (e) {
                        //     e.stopPropagation();
                        // });
                        // dateFromCloseEl.on("click", function (e) {
                        //     e.stopPropagation();
                        // });
                        // dateToCloseEl.on("click", function (e) {
                        //     e.stopPropagation();
                        // });

                        $(document).on("click", function (e) {
                            if($(e.target).closest(easyPickerElementsClass).length === 0 && $(e.target).closest(".easepick-wrapper").length === 0 && !hasTarget) {
                                jsEpWrapper.hide();
                            }
                        });
                    }
                    //we leave stop propagation here as the bind elements are hidden anyways. we need it because otherwise stuff will be closed
                    bindEl.on("click", function (e) {
                        // console.log("clicked on bindEL");
                        e.stopPropagation();
                    });
                    bindToEl.on("click", function (e) {
                        e.stopPropagation();
                    });
                    dateFromEl.on("focus", function (e) {
                        currSelectMode = "from";
                        // console.log("CURRSELECTMODE: ", currSelectMode);
                        dateToCloseEl.addClass("hidden");
                    });
                    //make sure the picker jumps to the right month
                    dateFromEl.on("click", function (e) {
                        // console.log("WE GOT CLICKED FROM");
                        // check if we have to scroll to the datepicker for target mode
                        if(hasTarget) {
                            scrollToTarget(scrollToBlock, scrollToBlockOffset);
                        }
                        currSelectMode = "from";
                        // let lockPl = easypicker.PluginManager.getInstance('LockPlugin');
                        // if(currDateTo) {
                        //     lockPl.options.inseparable = false;
                        // } else {
                        //     lockPl.options.inseparable = true;
                        // }


                        // console.log("CURRSELECTMODE: ", currSelectMode);
                        if(!ismobile && !hasTarget) {
                            // console.log("showing wrapper");
                            jsEpWrapper.show();
                        }
                        // console.log("easypicker.datePicked");
                        // console.log('currdate form DATE FROM CLICK');
                        // console.log(currDateFrom);
                        if(currDateFrom) {
                            gotoDate(currDateFrom, easypicker, false);
                            dateFromCloseEl.removeClass("hidden");
                        }

                        // console.log("SOMEINFOS From");
                        // console.log(currDateFrom);
                        // console.log(currDateTo);

                        // console.log("trigger from click and setting el");
                        // console.log(dateFromEl);

                        // easypicker.PluginManager.instances.RangePlugin.triggerElement = bindEl[0];
                        bindEl.trigger("click");
                        $(this).trigger("focus");
                    });
                    // dateToEl.on("touchstart", function (e) {
                    //     console.log("touchstart preventing dflt");
                    //     e.preventDefault();
                    // });
                    dateToEl.on("focus", function (e) {
                        if(currDateFrom) {
                            currSelectMode = "to";
                            // console.log("CURRSELECTMODE: ", currSelectMode);
                            dateFromCloseEl.addClass("hidden");
                        }
                    });
                    dateToEl.on("click", function (e) {
                        // console.log("WE GOT CLICKED TO");
                        // check if we have to scroll to the datepicker for target mode
                        if(hasTarget) {
                            scrollToTarget(scrollToBlock, scrollToBlockOffset);
                        }
                        // console.log("triggered dateToEl Click");
                        e.preventDefault();
                        if(!ismobile && !hasTarget) {
                            // console.log("showing wrapper");
                            jsEpWrapper.show();
                        }

                        if(!currDateFrom) {
                            dateFromCloseEl.trigger('click');
                            return false;
                        }
                        currSelectMode = "to";
                        // console.log("CURRSELECTMODE: ", currSelectMode);
                        // let lockPl = easypicker.PluginManager.getInstance('LockPlugin');
                        // lockPl.options.inseparable = true;

                        // console.log("easypicker.datePicked");
                        // console.log(easypicker.datePicked);
                        if(currDateTo) {
                            gotoDate(currDateTo, easypicker, true);
                            dateToCloseEl.removeClass("hidden");
                        }

                        //check if we need the click event
                        // console.log("SOMEINFOS To");
                        // console.log(currDateFrom);
                        // console.log(currDateTo);

                        // console.log("trigger to click and setting el");

                        easypicker.PluginManager.instances.RangePlugin.triggerElement = bindToEl[0];

                        bindToEl.trigger("click");
                        // console.log("reloading lockplugin");
                        // easypicker.PluginManager.reloadInstance('LockPlugin');
                        $(this).trigger("focus");
                    });
                    //check for preselection
                    // console.log("check for preselection");
                    // console.log(preSelectedFrom);
                    // console.log(preSelectedTo);

                    let initFromDate = ISOStringToDate(dateFromHiddenEl.val());
                    let initToDate = ISOStringToDate(dateToHiddenEl.val());
                    let firstOfMonth = new Date(initFromDate.getFullYear(), initFromDate.getMonth() - 2, 1, 0, 0, 0, 0);
                    let lastOfMonth = new Date(initToDate.getFullYear(), initToDate.getMonth() + (availabilityRange), 0, 23, 59, 59, 999);
                    let handlePreSelection = function () {
                        if(preSelectedFrom && preSelectedTo) {
                            // console.log("handling PRESELECT");
                            // console.log(easypicker.getStartDate());
                            // console.log(easypicker.getEndDate());
                            // currDateFrom = easypicker.getStartDate().clone();
                            // currMinDateTo = calculateMinDateTo(currDateFrom);
                            // currDateFromString = easePickerFormatDate(currDateFrom);
                            // currHiddenDateFromString = easePickerFormatDate(currDateFrom, "hidden");
                            //
                            // currDateTo = easypicker.getEndDate().clone();
                            // currMaxDateFrom = calculateMaxDateFrom(currDateTo);
                            // currDateToString = easePickerFormatDate(currDateTo);
                            // currHiddenDateToString = easePickerFormatDate(currDateTo, "hidden");









                            var dummyEFrom = {
                                start: easypicker.getStartDate(),
                                omitGotoCal: true,
                                omitNewPrice: true,
                                omitGotoDate: true
                            };
                            // doSelection(dummyE, preSelectedFrom);
                            easypicker.trigger("preselect", dummyEFrom);
                            var dummyETo = {
                                start: easypicker.getStartDate(),
                                end: easypicker.getEndDate(),
                                omitGotoCal: true,
                                omitNewPrice: true,
                                omitGotoDate: true
                            };
                            easypicker.trigger("preselect", dummyETo);
                            gotoDate(easypicker.getStartDate(), easypicker);
                            // // jsEpWrapper.hide();
                        }
                        // if(!ismobile) {
                        //     let stickyBoxContainer = $(".detail-search-box:first");
                        //     stickyBoxContainer.on("change", function (e) {
                        //         console.log("NEW PRICE STICKYBOX")
                        //         let rangePlugin = easypicker.PluginManager.getInstance("RangePlugin");
                        //         if(rangePlugin.options.loadNewPrice !== null) {
                        //             rangePlugin.options.loadNewPrice(currDateFrom, currDateTo);
                        //         }
                        //     });
                        // }
                    }
                    // let callback = handlePreSelection();
                    window.getAvailabilities(firstOfMonth, lastOfMonth, 'init', handlePreSelection);
                }
            });
            // console.log("--------------------after ep");
            dateFromCloseEl.on("click", function (e) {
                currSelectMode = 'from';
                // console.log("CURRSELECTMODE: ", currSelectMode);
                easypicker.clear();
                nightsCont.hide();
                dateFromHiddenEl.val("");
                dateFromEl.val("");
                currDateFrom = null;

                dateToHiddenEl.val("");
                dateToEl.val("");
                currDateTo = null;

                $(this).addClass("hidden");
                dateToCloseEl.addClass("hidden");
                dateFromEl.trigger("click");
                updateSomeInfo();
            });
            dateToCloseEl.on("click", function (e) {
                var startDate = easypicker.getStartDate();
                nightsCont.hide();
                // easypicker.clear();
                // dateFromHiddenEl.val("");
                dateToHiddenEl.val("");
                dateToEl.val("");
                currDateTo = null;
                if(startDate) {
                    // console.log("setting startDate");
                    // console.log(startDate);
                    // easypicker.setDateRange([startDate, null]);
                    easypicker.clear();
                    easypicker.setStartDate(startDate);
                    // easypicker.setEndDate(false);
                    // console.log(easypicker.getStartDate());
                    // console.log(easypicker.getEndDate());
                    // easypicker.setDateRange([startDate]);
                    // let applyBtn = $(easypicker.ui.container).find(".apply-button");
                    // applyBtn.trigger("click"); //force apply
                    dateToEl.trigger("click");
                } else {
                    dateFromEl.trigger("click");
                }

                $(this).addClass("hidden");
                updateSomeInfo();
            });


            // console.log("EASYPICKER");
            // console.log(easypicker);
            // console.log(easypicker.PluginManager);
            // console.log(easypicker.PluginManager.instances);
            // easypicker.on("view", function (e) {
            //     console.log("TEST123 ONVIEW");
            //     console.log(e.detail);
            // });
            // easypicker.on("render", function () {
            //     // console.log("TEST123 render");
            // });

        //
        });

    }

    // Only used when e.composedPath isn't available.
    function getEventPath(evt) {
        var path = [];
        var node = evt.target;

        while (node) {
            path.push(node);
            if (node.parentNode) {
                node = node.parentNode;        // normal DOM parent
            } else if (node.host) {
                node = node.host;              // jump out of a shadow root
            } else {
                node = null;
            }
        }
        path.push(window);                  // finish with window
        return path;
    }
    function updateUrlParams(params, { replace = false } = {}) {
        const url = new URL(window.location.href); // keeps path + hash
        Object.entries(params).forEach(([key, value]) => {
            if (value === null || value === undefined || value === '') {
                url.searchParams.delete(key);         // remove if empty/null
            } else {
                url.searchParams.set(key, String(value)); // add/update
            }
        });
        history[replace ? 'replaceState' : 'pushState']({}, '', url);
    }
}
